jQuery(document).ready(function($) {
    // document start

    $('.c-search-open-btn').on('click', function(e) {
        e.preventDefault();
        $('.c-search').addClass('c-search-open');
        $('html, body').addClass('c-search-open');
    });
    $('.c-search-close').on('click', function(e) {
        e.preventDefault();
        $('.c-search').removeClass('c-search-open');
        $('html, body').removeClass('c-search-open');
    });
    $('.menu-icon').on('click', function(e) {
        e.preventDefault();
        $('.c-nav-wpr').addClass('c-menu-open');
        $('html, body').addClass('c-menu-open');
    });
    $('.c-menu-close').on('click', function(e) {
        e.preventDefault();
        $('.c-nav-wpr').removeClass('c-menu-open');
        $('html, body').removeClass('c-menu-open');
    });
  //single product slider
if ($(".c_peoduct_slider").length) {
    $('.c_peoduct_slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        adaptiveHeight: true,
        centerPadding: '0px',
        asNavFor: '.c_peoduct_thumb_slider'
    });
    $('.c_peoduct_thumb_slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        centerPadding: '0px',
        asNavFor: '.c_peoduct_slider',
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }]
    });
}

    // document end

})